import { CheckOutlined, CloseOutlined, EnterOutlined } from '@ant-design/icons'
import { Button, Flex, Form, Input, Space, Tag, Typography } from 'antd'
import {
  capsRule,
  containsNumberRule,
  containsSymbolRule,
  lowercaseRule,
  minLengthRule,
  requiredRule,
} from '../../../helpers/rules'
import { OnboardingStepProps } from '../types'
import i18n from '../../../i18n/setupLocalization'
import LocalizationKeys from '../../../i18n/LocalizationKeys'

const { Title } = Typography

const PasswordStep = ({ onSuccess }: OnboardingStepProps) => {
  const formInstance = Form.useFormInstance()
  const passwordValue = Form.useWatch('password', formInstance)

  const checkBeforeSuccess = (nameList: string[]) => {
    formInstance
      .validateFields(nameList)
      .then((e) => onSuccess())
      .catch((e) => console.log(e))
  }

  const rules = [
    {
      rule: requiredRule(),
      label: i18n.t(LocalizationKeys.Misc.Error.Required),
      display: 'none',
    },
    {
      rule: minLengthRule(8),
      label: i18n.t(LocalizationKeys.Misc.Error.MinLength, { length: 8 }),
      tag: 'Min 8',
    },
    {
      rule: lowercaseRule(),
      label: i18n.t(LocalizationKeys.Misc.Error.Lowercase),
      tag: 'a-z',
    },
    {
      rule: capsRule(),
      label: i18n.t(LocalizationKeys.Misc.Error.Caps),
      tag: 'A-Z',
    },
    {
      rule: containsNumberRule(),
      label: i18n.t(LocalizationKeys.Misc.Error.ContainsNumber),
      tag: '0-9',
    },
    {
      rule: containsSymbolRule(),
      label: i18n.t(LocalizationKeys.Misc.Error.ContainsSymbol),
      tag: '!*$/',
    },
  ]

  const isRuleValid = (rule: any): boolean => {
    if (!passwordValue) return false
    if (rule.pattern) {
      return rule.pattern.test(passwordValue)
    }
    if (rule.validator) {
      try {
        rule.validator({}, passwordValue)
        return true
      } catch {
        return false
      }
    }
    return false
  }

  return (
    <Flex vertical>
      <Space>
        <Form.Item
          label={
            <Title className="m-0" level={5}>
              {i18n.t(
                LocalizationKeys.Page.OnboardingStepsPasswordPage.Password
              )}
            </Title>
          }
          name={'password'}
          rules={rules.map(({ rule }) => rule)}
          validateTrigger=""
          help={null}
        >
          <Input.Password
            className="authField"
            size="large"
            onPressEnter={(e) => {
              e.preventDefault()
              checkBeforeSuccess(['password'])
            }}
          />
        </Form.Item>
        <Button
          size="large"
          style={{ marginTop: 8 }}
          icon={<EnterOutlined />}
          onClick={() => checkBeforeSuccess(['password'])}
        ></Button>
      </Space>
      <Space className="w-full" size={5}>
        {rules
          .filter((item) => item.display !== 'none')
          .map(({ rule, label, tag }, index) => (
            <Space key={index}>
              {isRuleValid(rule) ? (
                <Tag color="purple" icon={<CheckOutlined />}>
                  {tag}
                </Tag>
              ) : (
                <Tag icon={<CloseOutlined />}>{tag}</Tag>
              )}
            </Space>
          ))}
      </Space>
    </Flex>
  )
}

export default PasswordStep
